import React from 'react';
import { css } from '@emotion/core';

const flexStyle = css`
  display: flex;
  flex-direction: row;
  align-content: space-between;
  justify-content: space-between;
  width: 100%;
`;

const IdLabel = ({ leftId, rightId }) => (
  <div css={flexStyle}>
    <h4>{leftId}</h4>
    <h4>{rightId}</h4>
  </div>
);

export default IdLabel;
